module.exports = __webpack_public_path__ + "static/media/NoirPro-Bold.9dbcc95d.woff";